module.exports = __webpack_public_path__ + "img/logo_full_small_white.52f31d45.png";